import {
  Array as RTArray,
  Null,
  Number as RTNumber,
  Record,
  Static,
  String as RTString,
  Undefined
} from 'runtypes';

export const IndividualBeneficiary = Record({
  taxID: RTString.Or(Undefined).Or(Null),
  percentage: RTNumber,
  beneficiaryType: RTString,
  name: Record({
    firstName: RTString,
    middleName: RTString.Or(Undefined).Or(Null),
    lastName: RTString,
    suffix: RTString
  }),
  dateOfBirth: RTString.Or(Undefined).Or(Null),
  relationship: RTString
});

export const EntityBeneficiary = Record({
  taxID: RTString,
  percentage: RTNumber,
  beneficiaryType: RTString,
  name: RTString
});

export const Beneficiary = Record({
  individuals: RTArray(IndividualBeneficiary),
  entities: RTArray(EntityBeneficiary)
});

export type StaticBeneficiary = Static<typeof Beneficiary>;
